import { render } from "./NotesListing.vue?vue&type=template&id=5833a9ec&scoped=true"
import script from "./NotesListing.vue?vue&type=script&lang=js"
export * from "./NotesListing.vue?vue&type=script&lang=js"

import "./NotesListing.vue?vue&type=style&index=0&id=5833a9ec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5833a9ec"]])

export default __exports__